import React, { Component } from "react";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import BiletIcon from "../../../static/icons/bilet.png";
import AnalysisView from "./AnalysisView";
import LoadingCircular from "../../LoadingCircular";

class Bilet extends Component {
  state = {
    open: false,
    selectedAlloy: "",
    selectedAlloyCode: "",
    isLoading: false,
    rows: [],
  };
  analysisData = [
    {
      code: "1009",
      analysis: [
        { element: "Si", min_value: "0.20", max_value: "0.6" },
        { element: "Fe", min_value: null, max_value: "0.35" },
        { element: "Cu", min_value: null, max_value: "0.10" },
        { element: "Mn", min_value: null, max_value: "0.10" },
        { element: "Mg", min_value: "0.45", max_value: "0.9" },
        { element: "Zn", min_value: null, max_value: "0.10" },
        { element: "Ti", min_value: null, max_value: "0.10" },
        { element: "Each", min_value: "0.05" },
        { element: "Total", min_value: "0.15" },
      ],
    },
    {
      code: "1036",
      analysis: [
        { element: "Si", min_value: "0.40", max_value: "0.8" },
        { element: "Fe", min_value: null, max_value: "0.7" },
        { element: "Cu", min_value: "0.15", max_value: "0.40" },
        { element: "Mn", min_value: null, max_value: "0.15" },
        { element: "Mg", min_value: "0.8", max_value: "1.2" },
        { element: "Zn", min_value: null, max_value: "0.25" },
        { element: "Ti", min_value: null, max_value: "0.15" },
        { element: "Cr", min_value: "0.04", max_value: "0.35" },
      ],
    },
    {
      code: "1050",
      analysis: [
        { element: "Si", min_value: null, max_value: "0.40" },
        { element: "Fe", min_value: null, max_value: "0.50" },
        { element: "Cu", min_value: "1.2", max_value: "2.0" },
        { element: "Mn", min_value: null, max_value: "0.30" },
        { element: "Mg", min_value: "2.1", max_value: "2.9" },
        { element: "Zn", min_value: "5.1", max_value: "6.1" },
        { element: "Ti", min_value: null, max_value: "0.20" },
        { element: "Cr", min_value: "0.18", max_value: "0.28" },
        { element: "Each", min_value: "0.05" },
        { element: "Total", min_value: "0.15" },
      ],
    },
    {
      code: "1049",
      analysis: [
        { element: "Si", min_value: null, max_value: "0.50" },
        { element: "Fe", min_value: null, max_value: "0.50" },
        { element: "Cu", min_value: "3.8", max_value: "4.9" },
        { element: "Mn", min_value: "0.30", max_value: "0.9" },
        { element: "Mg", min_value: "1.2", max_value: "1.8" },
        { element: "Zn", min_value: null, max_value: "0.25" },
        { element: "Ti", min_value: null, max_value: "0.15" },
        { element: "Cr", min_value: null, max_value: "0.10" },
        { element: "Each", min_value: "0.05" },
        { element: "Total", min_value: "0.15" },
      ],
    },
    {
      code: "1013",
      analysis: [
        { element: "Si", min_value: "0.7", max_value: "1.3" },
        { element: "Fe", min_value: null, max_value: "0.50" },
        { element: "Cu", min_value: null, max_value: "0.10" },
        { element: "Mn", min_value: "0.40", max_value: "1.0" },
        { element: "Mg", min_value: "0.6", max_value: "1.2" },
        { element: "Zn", min_value: null, max_value: "0.20" },
        { element: "Ti", min_value: null, max_value: "0.10" },
        { element: "Cr", min_value: null, max_value: "0.25" },
        { element: "Each", min_value: "0.05" },
        { element: "Total", min_value: "0.15" },
      ],
    },
    {
      code: "1014",
      analysis: [
        { element: "Si", min_value: null, max_value: "0.40" },
        { element: "Fe", min_value: null, max_value: "0.40" },
        { element: "Cu", min_value: null, max_value: "0.10" },
        { element: "Mn", min_value: null, max_value: "0.50" },
        { element: "Mg", min_value: "2.6", max_value: "3.6" },
        { element: "Zn", min_value: null, max_value: "0.20" },
        { element: "Ti", min_value: null, max_value: "0.15" },
        { element: "Cr", min_value: null, max_value: "0.30" },
        { element: "Each", min_value: "0.05" },
        { element: "Total", min_value: "0.15" },
      ],
    },
  ];
  getAnalysis = (name, code) => {
    this.setState({ isLoading: true });
    const data = this.analysisData.find((a) => a.code === code).analysis;
    this.setState({
      rows: data,
      isLoading: false,
      open: true,
      selectedAlloy: name,
      selectedAlloyCode: code,
    });
  };
  render() {
    return (
      <>
        <Typography sx={{ textAlign: "justify" }}>
          این شرکت مفتخر است اعلام نماید توانایی تولید هر نوع بیلت آلیاژی طبق
          استاندارد و یا سفارش مشتری را در سایزهای 6، 7 و 8 اینچ دارا می باشد،
          ضمنا برخی از بیلت های پرمصرف در ذیل آمده است.
        </Typography>
        <LoadingCircular open={this.state.isLoading} />
        <AnalysisView
          open={this.state.open}
          selectedAlloy={this.state.selectedAlloy}
          selectedAlloyCode={this.state.selectedAlloyCode}
          rows={this.state.rows}
          onClose={() => {
            this.setState({ open: false });
          }}
        />
        <List>
          {[
            { name: "6063", code: "1009" },
            { name: "6061", code: "1036" },
            { name: "7075", code: "1050" },
            { name: "2024", code: "1049" },
            { name: "6082", code: "1013" },
            { name: "5754", code: "1014" },
          ].map((alloy, index) => (
            <div key={alloy.name}>
              <ListItem key={alloy.name}>
                <ListItemAvatar>
                  <Avatar src={BiletIcon}></Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary={alloy.name}
                  secondary={
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => {
                        this.getAnalysis(alloy.name, alloy.code);
                      }}
                    >
                      آنالیز
                    </Button>
                  }
                />
              </ListItem>
              <Divider variant="inset" component="li" />
            </div>
          ))}
        </List>
      </>
    );
  }
}

export default Bilet;
